import { getRequest, postRequest, getcompanyIdNumber } from './api'

export async function list(size, index, searchTerm, orderBy) {
  searchTerm = 'webrequest'
  searchTerm = searchTerm || '%20';
  orderBy = orderBy || '%20';
  if (!searchTerm.includes('CompanyID')) {
    searchTerm = `${searchTerm}, CompanyID:${getcompanyIdNumber()},`
  }

  searchTerm = searchTerm || '%20';
  orderBy = orderBy || '%20';
  if (!searchTerm.includes('IsArchived')) {
    searchTerm = `${searchTerm}, IsArchived:false,`
  }

  return getRequest(
    `contract/get-list/${parseInt(size, 10) || 15}/${parseInt(index, 10) || 0}/${searchTerm || '%20'}/${orderBy || '%20'}`,
  )
}

export async function find(id) {
  console.log('find id', id)
  return getRequest(`contract/edit/${id}`)
}

// One project in the same shape as the project list rows (incl. the partner list the
// header shows) - honours the user's project access like the list does. Null when the
// user cannot see that project.
export async function findSelectable(id) {
  const result = await getRequest(`contract/get-list/1/0/ContractID:${id}/%20`)
  return result && result.items && result.items.length > 0 ? result.items[0] : null
}

export async function getMyCustomerContracts() {
  return getRequest('contract/my-contracts')
}

export async function save(values) {
  return postRequest(`contract/save`, values)
}

export function remove(values) {
  return postRequest(`contract/delete`, values)
}

export async function copyContract(values) {
  return postRequest(`contract/copy`, values)
}
